<template>
  <div>
    <div class="d-flex justify-content-between align-items-center mb-4">
      <h5 class="mb-0 font-weight-bold text-dark">Itens da Nota Fiscal</h5>
      <div class="d-flex align-items-center">
        <b-badge pill variant="light" class="mr-3 px-3 py-2 shadow-xs text-muted border">
          Total de Itens: <span class="text-primary font-weight-bold">{{ items.length }}</span>
        </b-badge>
        <b-button 
          size="sm" 
          variant="primary" 
          @click="$emit('add-item')" 
          :disabled="!podeEditar || loading"
          class="rounded-pill px-4 shadow-sm font-weight-bold"
        >
          <i class="fa fa-plus mr-1"></i> Adicionar Item
        </b-button>
      </div>
    </div>

    <b-overlay :show="loading" opacity="0.6" rounded="lg">
      <b-table 
        hover 
        responsive 
        :items="items" 
        :fields="fields" 
        class="premium-table"
        show-empty
        empty-text="Nenhum item adicionado a esta nota."
      >
        <template #cell(codigo)="data">
          <span class="text-muted font-weight-bold">#{{ data.item.ID_PRODUTO || '' }}</span>
        </template>
        <template #cell(descricao)="data">
          <div class="font-weight-bold text-dark">{{ data.item.TX_DESCRICAO }}</div>
        </template>
        <template #cell(ncm)="data">
          <b-badge variant="light" class="border text-muted">{{ data.item.TX_NCM || '-' }}</b-badge>
        </template>
        <template #cell(unidade)="data">
          <span class="badge badge-soft-info">{{ data.item.ID_UNIDADE_COMERCIAL || '' }}</span>
        </template>
        <template #cell(qtd)="data">
          <span class="font-weight-bold">{{ Number(data.item.NR_QUANT_COMERCIAL || 0).toLocaleString('pt-BR') }}</span>
        </template>
        <template #cell(vl_unitario)="data">
          <span class="text-muted">{{ formatCurrency(data.item.VL_UNITARIO_COMERCIAL) }}</span>
        </template>
        <template #cell(vl_total)="data">
          <span class="font-weight-bold text-primary">{{ formatCurrency(data.item.VL_TOTAL_BRUTO) }}</span>
        </template>
        <template #cell(icms)="data">
          <span class="text-info small font-weight-bold">{{ formatCurrency(data.item.VL_ICMS) }}</span>
        </template>
        <template #cell(ipi)="data">
          <span class="text-warning small font-weight-bold">{{ formatCurrency(data.item.VL_IPI) }}</span>
        </template>
        <template #cell(pis)="data">
          <span class="text-secondary small">{{ formatCurrency(data.item.VL_PIS) }}</span>
        </template>
        <template #cell(cofins)="data">
          <span class="text-secondary small">{{ formatCurrency(data.item.VL_COFINS) }}</span>
        </template>
        <template #cell(actions)="data">
          <div class="d-flex justify-content-end">
            <b-button 
              size="sm" 
              variant="outline-primary" 
              @click="$emit('edit-item', data.index)" 
              :disabled="!podeEditar || loading"
              class="btn-icon-only rounded-circle mr-1"
              title="Editar Item"
            >
              <i class="fa fa-pencil"></i>
            </b-button>
            <b-button 
              size="sm" 
              variant="outline-danger" 
              @click="$emit('remove-item', data.index)" 
              :disabled="!podeEditar || loading"
              class="btn-icon-only rounded-circle"
              title="Excluir Item"
            >
              <i class="fa fa-trash"></i>
            </b-button>
          </div>
        </template>
      </b-table>
    </b-overlay>
  </div>
</template>

<script>
import Tools from '@/tools/tools.js'

export default {
  name: 'NfeAbaProdutos',
  props: { 
    nfe: { type: Object, required: true },
    podeEditar: { type: Boolean, default: false },
    items: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false }
  },
  data() {
    return {
      fields: [
        { key: 'codigo', label: 'Cód.' , thStyle: { width: '6%' } },
        { key: 'descricao', label: 'Descrição' },
        { key: 'ncm', label: 'NCM', thStyle: { width: '8%' } },
        { key: 'unidade', label: 'Unid.', thStyle: { width: '6%' } },
        { key: 'qtd', label: 'Qtd', class: 'text-right', thStyle: { width: '8%' } },
        { key: 'vl_unitario', label: 'Vlr Unit.', class: 'text-right', thStyle: { width: '10%' } },
        { key: 'vl_total', label: 'Total', class: 'text-right', thStyle: { width: '10%' } },
        { key: 'icms', label: 'ICMS', class: 'text-right', thStyle: { width: '8%' } },
        { key: 'ipi', label: 'IPI', class: 'text-right', thStyle: { width: '8%' } },
        { key: 'pis', label: 'PIS', class: 'text-right', thStyle: { width: '8%' } },
        { key: 'cofins', label: 'COFINS', class: 'text-right', thStyle: { width: '8%' } },
        { key: 'actions', label: '', class: 'text-right', thStyle: { width: '8%' } }
      ]
    }
  },
  methods: {
    formatCurrency(v) {
      return Tools.formatCurrency(v)
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/faturamento/nfe/partials/NfeAbaProdutos.vue